import React from "react";

import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { useFlags } from "launchdarkly-react-client-sdk";

import { TaskV2, TaskV3 } from "@fartherfinance/frontend/api/Tasks/Types";

import TaskProgressIndicator from "../../../TaskProgressIndicator/TaskProgressIndicator";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TableTaskTitle.module.css";

interface TableTaskTitleProps {
  task: TaskV2 | TaskV3;
}

const TableTaskTitle: React.FC<TableTaskTitleProps> = ({ task }) => {
  const { enableTaskSubtasks } = useFlags();

  const subtasks = task.children?.tasks ?? [];

  return (
    <div className={styles.taskTitleContainer}>
      <Text className={styles.shrinkLess} variant="body" noWrap>
        {task.title}
      </Text>

      {enableTaskSubtasks && (
        <>
          {subtasks.length > 0 && (
            <TaskProgressIndicator task={task} subtasks={subtasks} />
          )}

          {task.parent && (
            <div className={styles.parentTaskContainer}>
              <ChevronRightRoundedIcon className={styles.icon} />
              <Text
                className={styles.shrinkMore}
                variant="body"
                color="textSubtle"
                noWrap
              >
                {task.parent.title}
              </Text>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TableTaskTitle;
